export default "/_nuxt/2a4fc258fcdc8a2dc75d74c2fee52d89.svg";